import dayjs from 'dayjs';

const dateSort = (dateA, dateB) => dayjs(dateA).diff(dayjs(dateB));

const defaultSort = (a, b) => {
    return a - b;
};

export const Sorter = {
    DEFAULT: defaultSort,
    DATE: dateSort,
};